import { Component, OnInit } from '@angular/core';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { first } from 'rxjs';
import { ReportsService } from 'src/app/services/reports.service';
import { MenuItem, MessageService } from 'primeng/api';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import saveAs from 'file-saver';
@Component({
  selector: 'app-pond-da-report',
  templateUrl: './pond-da-report.component.html',
  styleUrls: ['./pond-da-report.component.scss']
})
export class PondDaReportComponent implements OnInit {

  date:any;
  userId:any;
  appVerificationItems: MenuItem[];
 appVerificationModel:any;
 pondData:any;
 cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
 exportColumns: { title: string; dataKey: string; }[];
   constructor(private service: BaseService,private loader: AppLoaderService,private reportsService:ReportsService,private messageService:MessageService,private cryptoJs: CryptoJsService) { }
 
   ngOnInit(): void {
     
    const encData = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJs.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encData);

    const userId = loginDetails.get('User_name_while_login') ? loginDetails.get('User_name_while_login') : null;

    this.userId = userId;
     // console.log(this.userId,"this.userIdthis.userIdthis.userIdthis.userIdthis.userIdthis.userId")
    //  this.userId=encodeURIComponent(this.cryptoJs.Encrypt(this.userId))
  this.service.selectedDate.subscribe(res => this.date = res);
  this.loadData();
  this.appVerificationItems = [
    {
      label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
        this.exportExcel(this.appVerificationModel, "DA_wise_report");
      }
    },
    {
      label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
        this.downloadSheetAsPdf(this.appVerificationModel, "DA_wise_report");
      }
    },
  ];
 
   }
   // ngOnChanges() {
   //   // changes.prop contains the old and the new value...
   //   this.service.selectedDate.subscribe(res => {
   //     if(this.date !== res){
   //       this.date=res;
   //       this.loadData()
   //     }
   //   });
 
   // }
   loadData(){
     this.loader.start();
     this.reportsService.getDDAssociateDailyTaskPond(this.userId,this.date,'')
         .pipe(first())
         .subscribe({
           next: (data) => {
             this.loader.close();
             // this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (District Wise)', '', new Date(), 'Success');
 
            //  console.log("dataaa", data)
             if (data?.length > 0) {
              data.forEach(e=>{
                e.Date=new Date(e.Date)
                e.Date_filter=e.Date.toString().substr(4,11)

              })
              this.pondData=data
              this.appVerificationModel = data;
              
             }
           },
           error: (err) => {
             this.loader.close();
             // this.activityRecordService.activityRecord(this.userID, 'Application Verification Report (District Wise)', '', new Date(), err);
 
             this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
 
           }
         });
   }
   exportExcel(modelData, filename) {
    
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        // console.log(d)
        return {
          "UserId" : d.UserId,
          "Date": d.Date_filter,
          "District": d.District,
          "Applicant Type": d.Applicant_Type,
          "PV Stage1":d.PVStage1,
          "PV Stage1 MR": d.PVStage1_MR,
          "PV Stage2": d.PVStage2,
          "PV Stage2 MR": d.PVStage2_MR,
          "PV Stage3": d.PVStage3,
          "PV Stage3 MR": d.PVStage3_MR,

        }
      })
      
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      ); 
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      {field: 'UserId', header: 'UserId'},
      { field: 'Date_filter', header: 'Date' },
      { field: 'District', header: 'District' },
      { field: 'Applicant_Type', header: 'Applicant Type' },
      { field: 'PVStage1', header: 'PVStage1' },
      { field: 'PVStage1_MR', header: 'PVStage1 MR' },
      { field: 'PVStage2', header: 'PVStage2' },
      { field: 'PVStage2_MR', header: 'PVStage2_MR' },
      { field: 'PVStage3', header: 'PV Stage3' },
      { field: 'PVStage3_MR', header: 'PV Stage3 MR' },

    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }

}
